import { Newsletter } from 'ui/components/3-organisms/Newsletter';

export const NewsletterSignupFeature: React.FC<Content.NewsletterSignup> = ({ content }) => (
	<Newsletter {...content?.properties} />
);
